<script setup lang="ts">
import { useDefaultStore } from "@/store";

const store = useDefaultStore();
</script>

<template lang="pug">
.legal-contact-wrapper
	.cover-wrapper
	.content-wrapper
		.paragraph-top {{ $t("app.legalContact.textTop") }}
		.paragraph-bottom {{ $t("app.legalContact.textBottom") }}
		.button-wrapper
			a.home-page-white-button.call-us-button(
				href="tel:+38163267266",
				aria-label="Call us",
				@click="store.trackClickCall()"
			)
				span.post-button-text {{ $t("app.callUs").toLocaleUpperCase() }}
				span.post-button-text 063/267-266
</template>

<style lang="scss" scoped>
.legal-contact-wrapper {
	display: flex;
	flex-direction: column-reverse;
	background-color: $app-dark-color;
	.cover-wrapper {
		aspect-ratio: 100 / 78;
		background-image: url("@/assets/image/legalContact/velika-kompanija-koja-se-napaja-strujom-iz-solarnih-panela.png");
		background-repeat: no-repeat;
		background-size: cover;
		background-position: left;
		div {
			position: relative;
			.cover {
				width: 100%;
			}

			.watermark {
				position: absolute;
				width: 12%;
				right: 2%;
				bottom: 4%;
			}
		}
	}

	.content-wrapper {
		padding: 24px;
		.paragraph-top {
			color: $text-color-lighter;
			font-family: Pelinka, sans-serif;
			font-size: 20px;
			line-height: 26px;
			margin-bottom: 24px;
			font-weight: 700;
		}

		.paragraph-bottom {
			color: $text-color-lighter;
			font-family: "Galano Grotesque Alt", sans-serif;
			font-size: 20px;
			line-height: 26px;
			font-weight: 300;
			margin-bottom: 24px;
		}

		.button-wrapper {
			display: flex;
			justify-content: center;
		}
	}
}

@media screen and (width >= 760px) {
	.legal-contact-wrapper {
		.content-wrapper {
			.paragraph-top,
			.paragraph-bottom {
				font-size: 22px;
				line-height: 28px;
			}

			.paragraph-top {
				margin-top: 26px;
			}

			.button-wrapper {
				margin-bottom: 26px;
			}
		}
	}
}

@media screen and (width >= 1024px) {
	.legal-contact-wrapper {
		.content-wrapper {
			padding: 85px;

			.paragraph-top {
				margin-top: 0;
			}

			.paragraph-bottom {
				margin-bottom: 50px;
			}

			.button-wrapper {
				margin-bottom: 0;
			}
		}
	}
}

@media screen and (width >= 1224px) {
	.legal-contact-wrapper {
		padding: 85px;
		.content-wrapper {
			padding: 0;

			.paragraph-top,
			.paragraph-bottom {
				font-size: 26px;
				line-height: 32px;
				margin-bottom: 50px;
			}
		}

		// .cover-wrapper {
		// 	display: none;
		// }
	}
}

@media screen and (width >= 1224px) {
	.legal-contact-wrapper {
		padding: 0;
		flex-direction: row;
		.content-wrapper {
			width: 57%;
			padding: 85px;
			display: flex;
			flex-direction: column;
			justify-content: space-around;

			.paragraph-top,
			.paragraph-bottom {
				font-size: 30px;
				line-height: 34.5px;
				margin-bottom: 50px;
			}

			.button-wrapper {
				justify-content: start;
			}
		}

		.cover-wrapper {
			width: 43%;
			// display: flex;
		}
	}
}
</style>
